import { render, staticRenderFns } from "./FeatureSwitch.vue?vue&type=template&id=6f0d1bb0&"
import script from "./FeatureSwitch.vue?vue&type=script&lang=js&"
export * from "./FeatureSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports